/**
 * HeightReserver - keeps children in layout but invisible, so a row swapping to a different state
 * (e.g. delete-confirm) keeps the exact height of its display state however many lines the content
 * wrapped to.
 *
 * `visibility: hidden` rather than `display: none` so the box still occupies space, and
 * `aria-hidden` so assistive tech doesn't read content the user can't see — the replacing state's
 * own text speaks for the row. Pair with gridStackClass to overlay the replacement in the same cell.
 */
const HeightReserver = ({ children }) => (
  <div style={{ visibility: "hidden" }} aria-hidden="true">
    {children}
  </div>
);

export default HeightReserver;
